<template>
  <period-filter
    ref="periodFilter"
    :loadingList="isLoading"
    :dropdownOptions="dropdownOptions"
    :selectedPeriod="selectedPeriod"
    @dateFiltersChanged="search"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PeriodFilter from '@/components/project/globals/PeriodFilter.vue'

import { DATE_PICKER_OPTIONS } from '@/enums/date-picker.enum'
import Amplitude from '@/amplitude-events/resume.amplitude'

export default {
  name: 'DateSelect',
  components: {
    PeriodFilter
  },
  props: {
    isLoading: Boolean
  },

  data () {
    return {
      selectedPeriod: DATE_PICKER_OPTIONS.TODAY,
      dropdownOptions: DATE_PICKER_OPTIONS.NON_ALL_TIME
    }
  },

  computed: {
    ...mapGetters(['account', 'merchant']),

    queryPeriodFilter () {
      return this.$refs?.periodFilter?.prepareQuery()
    }
  },

  mounted () {
    this.refreshRoute(this.queryPeriodFilter)

    this.search()
  },

  methods: {
    ...mapActions(['GET_CHARGES']),

    refreshRoute (query) {
      this.$router.replace({ query }).catch(err => err)
    },
    search () {
      const query = {
        ...this.queryPeriodFilter,
        customer_ids: this.$route.params.id,
        sort_mode: this.$route.query.sort_mode || 'DESC'
      }

      const params = {
        merchantId: this.merchant.id,
        accountId: this.account.id,
        query
      }

      Amplitude.events.filters.periodChanged(query)

      this.GET_CHARGES(params)

      this.trackClickGA(
        'Seleção de período',
        query.date_filters ?? query.period_type
      )

      this.refreshRoute(query)
    },

    trackClickGA (eventName, value) {
      if (this.$gtag)
        this.$gtag.event(eventName, {
          event_category: 'Filtro Home Dash',
          event_label: value
        })
    }
  }
}
</script>
